import { render, staticRenderFns } from "./highlyCitedArticles.vue?vue&type=template&id=39b12f60&scoped=true"
import script from "./highlyCitedArticles.vue?vue&type=script&lang=js"
export * from "./highlyCitedArticles.vue?vue&type=script&lang=js"
import style0 from "./highlyCitedArticles.vue?vue&type=style&index=0&id=39b12f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b12f60",
  null
  
)

export default component.exports